export const benefitsSliderOptions = (instance, options) => {
    let responsiveItemCounts = {
        1024: 4,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution];

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: 1,
            spaceBetween: 0,
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 34,
        cssMode: false,
        pagination: {
            el: instance.paginationEl,
            type: 'bullets',
            clickable: true,
            dynamicBullets: false,
            dynamicMainBullets: 10,
            hideOnClick: false,
        },
        breakpoints: breakpoints
    }
}